@file:OptIn(InternalResourceApi::class)

package inspection.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/inspection.composeapp.generated.resources/"

@delegate:ResourceContentHash(691_127_343)
internal val Res.string.title_login_screen: StringResource by lazy {
      StringResource("string:title_login_screen", "title_login_screen", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4691, 34),
      ))
    }

@delegate:ResourceContentHash(-1_258_765_393)
internal val Res.string.total_attention_question: StringResource by lazy {
      StringResource("string:total_attention_question", "total_attention_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4726, 92),
      ))
    }

@delegate:ResourceContentHash(-555_756_695)
internal val Res.string.total_file: StringResource by lazy {
      StringResource("string:total_file", "total_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4819, 34),
      ))
    }

@delegate:ResourceContentHash(-380_062_378)
internal val Res.string.total_pages_and_question: StringResource by lazy {
      StringResource("string:total_pages_and_question", "total_pages_and_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4854, 72),
      ))
    }

@delegate:ResourceContentHash(-329_764_269)
internal val Res.string.total_photo: StringResource by lazy {
      StringResource("string:total_photo", "total_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4927, 35),
      ))
    }

@delegate:ResourceContentHash(557_644_196)
internal val Res.string.trailing_icon_button: StringResource by lazy {
      StringResource("string:trailing_icon_button", "trailing_icon_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4963, 56),
      ))
    }

@delegate:ResourceContentHash(282_614_663)
internal val Res.string.unanswered_question: StringResource by lazy {
      StringResource("string:unanswered_question", "unanswered_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5020, 55),
      ))
    }

@delegate:ResourceContentHash(89_263_559)
internal val Res.string.vessel: StringResource by lazy {
      StringResource("string:vessel", "vessel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5076, 22),
      ))
    }

@delegate:ResourceContentHash(-1_938_010_970)
internal val Res.string.view_report: StringResource by lazy {
      StringResource("string:view_report", "view_report", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5099, 35),
      ))
    }

@delegate:ResourceContentHash(2_678_212)
internal val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5135, 15),
      ))
    }

@delegate:ResourceContentHash(-2_112_296_936)
internal val Res.string.you_confirm_audit_reviewed: StringResource by lazy {
      StringResource("string:you_confirm_audit_reviewed", "you_confirm_audit_reviewed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5151, 134),
      ))
    }

@delegate:ResourceContentHash(1_626_529_106)
internal val Res.string.your_progress_is_saved: StringResource by lazy {
      StringResource("string:your_progress_is_saved", "your_progress_is_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5286, 118),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("title_login_screen", Res.string.title_login_screen)
  map.put("total_attention_question", Res.string.total_attention_question)
  map.put("total_file", Res.string.total_file)
  map.put("total_pages_and_question", Res.string.total_pages_and_question)
  map.put("total_photo", Res.string.total_photo)
  map.put("trailing_icon_button", Res.string.trailing_icon_button)
  map.put("unanswered_question", Res.string.unanswered_question)
  map.put("vessel", Res.string.vessel)
  map.put("view_report", Res.string.view_report)
  map.put("yes", Res.string.yes)
  map.put("you_confirm_audit_reviewed", Res.string.you_confirm_audit_reviewed)
  map.put("your_progress_is_saved", Res.string.your_progress_is_saved)
}
